export const InValidNumbers = ['e', 'E', '+', '-', '.'];
export const InvalidFloatingNumbers = ['e', 'E', '+', '-'];
